module.exports = __webpack_public_path__ + "img/LATIN10.f025fc60.png";